
<div class="newsTitle">
	<mat-icon>newspaper</mat-icon>
	<h1>{{news.title}}</h1>
</div>


<div style="margin: 2em 0">
	<h2>{{ news.creationTms | date: "dd.MM.YYYY" }}</h2>
</div>


<div
	class="htmlViewer"
	[innerHTML]="newsContent">
</div>

<div class="contactDetails">
  <h4>Ansprechpartner:</h4>
  <div>&emsp;{{contactTitle }} {{ contactFirstName }} {{ contactFamilyName }}</div>
  <div>&emsp;{{ contactPhone }}</div>
  <div>&emsp;{{ contactEmail }}</div>
</div>



